import { newEmojis } from './emojis';
import { tags } from './link';

export const parseEmoji = (str: string, revers?: boolean) => {
  if (!str) return '';
  let newStr = '';
  let newStr2 = '';
  newEmojis.forEach((em) => {
    if (revers) {
      if (newStr) {
        return (newStr = newStr.replaceAll(`<img style="width: 16px; height: 16px" src="${em.link}" alt="${em.name}">`, em.code));
      }
      newStr = str.replaceAll(`<img style="width: 16px; height: 16px" src="${em.link}" alt="${em.name}">`, em.code);
    } else {
      if (newStr) {
        return (newStr = newStr.replaceAll(em.code, `<img style="width: 16px; height: 16px" src="${em.link}" alt="${em.name}"/>`));
      }
      newStr = str.replaceAll(em.code, `<img style="width: 16px; height: 16px" src="${em.link}" alt="${em.name}"/>`);
    }
  });

  tags.forEach((item) => {
    if (revers) {
      if (newStr2) {
        return (newStr2 = newStr2.replaceAll(item.tag, item.el));
      }
      newStr2 = newStr.replaceAll(item.tag, item.el);
    } else {
      if (newStr2) {
        return (newStr2 = newStr2.replaceAll(item.el, item.tag));
      }
      newStr2 = newStr.replaceAll(item.el, item.tag);
    }
  });

  return newStr2;
};
